<template>
  <div class="related-stop-dates flex flex-gap-1">
    <NamedAddress
      :name="relatedStop.location.locationName"
      :address="relatedStop.location.toAddress()"
    />

    <div class="dates flex-grow-1 flex flex-gap-1 justify-content-between">
      <LocationCardDateRange
        :label="
          relatedStop.stopType === ShipmentStopType.PICKUP
            ? t('shipments.dates.requestedPickup')
            : t('shipments.dates.requestedDropoff')
        "
        :start="relatedStop.requestedAppointmentEarliest"
        :end="relatedStop.requestedAppointmentLatest"
        uppercase-label
      />

      <LocationCardDateRange
        :label="
          relatedStop.stopType === ShipmentStopType.PICKUP
            ? t('shipments.dates.scheduledPickup')
            : t('shipments.dates.scheduledDropoff')
        "
        :start="relatedStop.scheduledAppointmentEarliest"
        :end="relatedStop.scheduledAppointmentLatest"
        uppercase-label
      />

      <LocationCardDate
        :label="
          relatedStop.stopType === ShipmentStopType.PICKUP
            ? t('shipments.dates.expectedPickup')
            : t('shipments.dates.expectedDropoff')
        "
        :date="relatedStop.expectedArrival"
        uppercase-label
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { ShipmentStop, ShipmentStopType } from '@/model';

import LocationCardDate from '@/components/location/LocationCardDate.vue';
import LocationCardDateRange from '@/components/location/LocationCardDateRange.vue';
import NamedAddress from '@rygen/rygen-ui/components/address/NamedAddress.vue';

const props = defineProps({
  relatedStop: {
    type: Object as PropType<ShipmentStop>,
    default: () => new ShipmentStop(),
  },
});
const { relatedStop } = toRefs(props);

const { t } = useI18n();
</script>

<style>
.related-stop-dates {
  padding-top: var(--sp-3);
  border-top: var(--divider);

  .named-address {
    padding-right: var(--sp-3);
    border-right: var(--divider);
  }
}
</style>
